// Game constants
export const STACK_BASE_RANK = 0;
export const UNKNOWN_CARD_RANK = 6;
export const START_CARD_RANK = 7;
export const MAX_RANK = 7;
export const MAX_CLUE_NUM = 8;
export const MAX_STRIKES = 3;
export const DEFAULT_VARIANT_NAME = "No Variant";
